import PropertyForm from "../components/PropertyFormPG";
import UnitForm from "../../units/components/UnitFormPG";
// import UploadImageForm from "../../../components/forms/UploadImageForm";
// import UploadImageForm2 from "../../../components/forms/UploadImageForm2";
import UploadImageForm from "../../../components/forms/UploadImageFormPG";
// import LocationForm from "../../../components/forms/LocationForm";
import LocationForm from "../../../components/forms/LocationFormPG";

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  Typography,
  Paper,
  Divider,
} from "@mui/material";
import {
  Close as CloseIcon,
  CheckCircleOutline as SuccessIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
// import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useAddNewPropertyMutation } from "../propertiesApiSlice";
import { useGetUnitTypesQuery } from "../../unitTypes/unitTypesApiSlice";

const steps = ["Property Details", "Location & Address", "Unit Details"];

const AddProperty = () => {
  const navigate = useNavigate();
  const [addNewProperty, { isLoading }] = useAddNewPropertyMutation();

  // Step State
  const [activeStep, setActiveStep] = useState(0);

  // Form Data State
  const [formData, setFormData] = useState({
    property: {
      title: "",
      propertyType: "",
      gender: "",
      tenantType: "",
      managerName: "",
      managerPhone: "",
      amenities: [],
      rules: [],
    },
    uploadImage: {
      images: [],
      mainImage: null,
    },
    location: {
      //   searchLocation: "",
      //   lat: "",
      //   lng: "",
      //   gpsLocation: "",
      //   gpsAddress: "",
      //   location: "",
      //   country: "",
      //   city: "",

      buildingName: "",
      streetAddress: "",
      area: "",
      countryId: "",
      stateId: "",
      cityId: "",
      cityName: "",
      pincode: "",
      lat: "",
      lng: "",
      nearestLandmark: "",
      landmarkDistance: "",
      transportTypeId: "",
      transportName: "",
      transportDistance: "",
    },
    unit: {
      unitType: "",
      //   totalBeds: 1, // Added based on previous context
      //   price: "",
      //   paymentFrequency: "",
      //   unitImages: [],
      //   unitMainImage: "",
      //   startDate: null,
      //   endDate: null,
      //   comments: "",
      // Add other unit fields if needed
      bathroomType: "", // Add default value
      size: "",
      amenities: [], // Add this
      //   foodIncluded: [], // Add this
      foodDetails: {
        isAvailable: false,
        dietaryPreference: "veg",
        mealsProvided: [],
      },
      price: "",
      securityDeposit: "",
      noticePeriod: "30", // Add default value
      //   startDate: null,
      //   endDate: null,
      unitImages: [],
      unitMainImage: null, // Changed from empty string to null
      comments: "",
    },
  });

  // Refs
  const propertyFormRef = useRef();
  const uploadImageFormRef = useRef();
  const locationFormRef = useRef();
  const unitFormRef = useRef();
  const errRef = useRef();
  const successRef = useRef();

  // API State
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  //   const [successPropertyId, setSuccessPropertyId] = useState(null); // Renamed for clarity

  const propertyType = formData.property?.propertyType;

  // Fetch Unit Types
  const {
    data: fetchedUnitTypes,
    isLoading: isUnitTypeLoading,
    isError: isUnitTypeError,
  } = useGetUnitTypesQuery(propertyType, {
    skip: !propertyType,
  });

  // Auto-focus error/success
  useEffect(() => {
    if (errMsg && errRef.current) errRef.current.focus();
    if (success && successRef.current) successRef.current.focus();
  }, [errMsg, success]);

  //   useEffect(() => {
  //     window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  //   }, [activeStep, successPropertyId]);

  // Handle Data Updates
  const handleDataChange = (section, data) => {
    setFormData((prev) => ({
      ...prev,
      [section]: { ...prev[section], ...data },
    }));
  };

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  // --- NAVIGATION LOGIC ---

  const handleNext = () => {
    let isValid = false;

    // Step 0: Property Info + Images
    if (activeStep === 0) {
      const isPropertyValid = propertyFormRef.current?.validateUserInput();
      if (!isPropertyValid) {
        return;
      }

      const isImageValid = uploadImageFormRef.current?.validateUserInput();
      if (!isImageValid) {
        return;
      }

      isValid = true;
    }
    // Step 1: Location
    else if (activeStep === 1) {
      const isLocationValid = locationFormRef.current?.validateUserInput();
      if (isLocationValid) {
        isValid = true;
      }
    }
    // Step 2: Unit (Handled by handleSubmit)
    else if (activeStep === 2) {
      isValid = true;
    }

    if (isValid) {
      setActiveStep((prevStep) => prevStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // --- SUBMISSION LOGIC ---

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. CLEAR ERRORS IMMEDIATELY
    // This removes the old alert box as soon as the user clicks the button.
    setErrMsg("");
    setSuccess(false); // Optional: clear success state if you allow re-submissions
    setIsSubmitted(true);

    // Final Validation (Unit Form)
    const isUnitValid = unitFormRef.current?.validateUserInput();
    if (!isUnitValid) return;

    // Prepare FormData
    const formDataToSubmit = new FormData();

    // --- 1. PROPERTY DATA ---
    // Map Frontend keys to Backend keys explicitly
    formDataToSubmit.append("title", formData.property.title);
    formDataToSubmit.append("propertyType", formData.property.propertyType);

    formDataToSubmit.append("gender", formData.property.gender);
    formDataToSubmit.append("tenantType", formData.property.tenantType);
    formDataToSubmit.append("managerName", formData.property.managerName);
    formDataToSubmit.append("managerPhone", formData.property.managerPhone);

    // ARRAYS: Must be JSON stringified for Backend to parse safely
    formDataToSubmit.append(
      "amenities",
      JSON.stringify(formData.property.amenities || [])
    );
    formDataToSubmit.append(
      "rules",
      JSON.stringify(formData.property.rules || [])
    );

    // // 1. Property Data
    // Object.keys(formData.property).forEach((key) => {
    //   if (key === "commonAmenities" || key === "rules") {
    //     formDataToSubmit.append(
    //       key,
    //       JSON.stringify(formData.property[key] || [])
    //     );
    //   } else {
    //     formDataToSubmit.append(key, formData.property[key]);
    //   }
    // });

    // Property Images
    if (formData.uploadImage.mainImage?.file) {
      formDataToSubmit.append("mainImage", formData.uploadImage.mainImage.file);
    }
    formData.uploadImage.images.forEach((image) => {
      formDataToSubmit.append("images", image.file);
    });

    // --- 2. LOCATION DATA ---
    // Simple fields
    formDataToSubmit.append("buildingName", formData.location.buildingName);
    formDataToSubmit.append("streetAddress", formData.location.streetAddress);
    formDataToSubmit.append("area", formData.location.area);
    formDataToSubmit.append("cityId", formData.location.cityId);
    formDataToSubmit.append("cityName", formData.location.cityName);
    formDataToSubmit.append("stateId", formData.location.stateId);
    formDataToSubmit.append("pincode", formData.location.pincode);
    formDataToSubmit.append("lat", formData.location.lat);
    formDataToSubmit.append("lng", formData.location.lng);
    formDataToSubmit.append(
      "nearestLandmark",
      formData.location.nearestLandmark
    );
    formDataToSubmit.append(
      "landmarkDistance",
      formData.location.landmarkDistance
    );

    // COMPLEX: Construct the Transport Array (Backend expects 'nearbyTransport')
    // We take the single entry from the form and wrap it in an array
    if (formData.location.transportTypeId) {
      const transportArray = [
        {
          transportTypeId: formData.location.transportTypeId,
          stationName: formData.location.transportName,
          distanceMetres: formData.location.transportDistance,
        },
      ];
      formDataToSubmit.append(
        "nearbyTransport",
        JSON.stringify(transportArray)
      );
    } else {
      formDataToSubmit.append("nearbyTransport", JSON.stringify([]));
    }

    // --- 3. UNIT DATA ---
    formDataToSubmit.append("unitType", formData.unit.unitType);
    formDataToSubmit.append("bathroomType", formData.unit.bathroomType);
    formDataToSubmit.append("size", formData.unit.size);
    formDataToSubmit.append("price", formData.unit.price);
    formDataToSubmit.append("securityDeposit", formData.unit.securityDeposit);
    formDataToSubmit.append("noticePeriod", formData.unit.noticePeriod);
    // formDataToSubmit.append("totalUnits", formData.unit.totalUnits || 1); // Ensure this exists
    formDataToSubmit.append("comments", formData.unit.comments);

    // COMPLEX OBJECTS: JSON Stringify
    formDataToSubmit.append(
      "unitAmenities",
      JSON.stringify(formData.unit.amenities || [])
    ); // Backend key is 'unitAmenities'
    formDataToSubmit.append(
      "foodDetails",
      JSON.stringify(formData.unit.foodDetails || {})
    );

    // Object.keys(formData.unit).forEach((key) => {
    //   // Skip images and dates for manual handling
    //   if (
    //     key !== "unitImages" &&
    //     key !== "unitMainImage"
    //     // &&
    //     // key !== "startDate" &&
    //     // key !== "endDate"
    //   ) {
    //     formDataToSubmit.append(key, formData.unit[key]);
    //   }
    // });

    // Unit Images
    if (formData.unit.unitMainImage?.file) {
      formDataToSubmit.append(
        "unitMainImage",
        formData.unit.unitMainImage.file
      );
    }
    formData.unit.unitImages.forEach((unitImage) => {
      formDataToSubmit.append("unitImages", unitImage.file);
    });

    // Unit Dates
    // formDataToSubmit.append(
    //   "startDate",
    //   formData.unit.startDate ? formData.unit.startDate.toISOString() : null
    // );
    // formDataToSubmit.append(
    //   "endDate",
    //   formData.unit.endDate ? formData.unit.endDate.toISOString() : null
    // );

    try {
      const addProperty = await addNewProperty(formDataToSubmit).unwrap();
      if (addProperty) {
        setSuccess(addProperty.id);
        setActiveStep(2); // Move to a "Success" step or stay on last
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (err) {
      if (!err.status) {
        setErrMsg("No Server Response");
      } else {
        setErrMsg(err.data?.message || "Submission failed");
      }
      setIsSubmitted(false);
    }

    // try {
    //   const response = await addNewProperty(formDataToSubmit).unwrap();

    //   // FIXED: Use 'propertyId' from backend response, OR fallback to 'id'
    //   const newItemId = response.propertyId || response.id;

    //   if (newItemId) {
    //     setSuccessPropertyId(newItemId);
    //     // Do NOT increment activeStep to 3 here, rely on conditional rendering
    //   } else {
    //     throw new Error("Property ID missing in server response");
    //   }
    // } catch (err) {
    //   console.error("Submission Error", err);
    //   setErrMsg(err.data?.message || err.message || "Submission failed");
    // }
  };

  // --- RENDER CONTENT ---

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <>
            <PropertyForm
              ref={propertyFormRef}
              initialData={formData.property}
              onDataChange={(data) => handleDataChange("property", data)}
            />
            <UploadImageForm
              ref={uploadImageFormRef}
              initialData={formData.uploadImage}
              onDataChange={(data) => handleDataChange("uploadImage", data)}
              //   imageInfo={"Property exterior *"}
              imageInfo={"Property Photos"}
            />
          </>
        );
      case 1:
        return (
          <LocationForm
            ref={locationFormRef}
            initialData={formData.location}
            onDataChange={(data) => handleDataChange("location", data)}
          />
        );
      case 2:
        return (
          <UnitForm
            ref={unitFormRef}
            unitTypes={fetchedUnitTypes}
            isLoading={isUnitTypeLoading}
            isError={isUnitTypeError}
            initialData={formData.unit}
            onDataChange={(data) => handleDataChange("unit", data)}
            parent={"Property Type"}
          />
        );
      default:
        return <Typography>Unknown Step</Typography>;
    }
  };

  // --- SUCCESS VIEW COMPONENT ---
  //   if (successPropertyId) {
  //     return (
  //       <Container maxWidth="sm" sx={{ mt: 8, mb: 5 }}>
  //         <Paper
  //           elevation={3}
  //           sx={{
  //             p: 5,
  //             display: "flex",
  //             flexDirection: "column",
  //             alignItems: "center",
  //             textAlign: "center",
  //             borderRadius: 3,
  //           }}
  //         >
  //           <SuccessIcon color="success" sx={{ fontSize: 80, mb: 2 }} />
  //           <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
  //             Success!
  //           </Typography>
  //           <Typography variant="body1" color="text.secondary" paragraph>
  //             Your property <strong>{formData.property.title}</strong> has been
  //             listed successfully.
  //           </Typography>

  //           <Divider sx={{ width: "100%", my: 3 }} />

  //           <Box
  //             sx={{
  //               display: "flex",
  //               flexDirection: "column",
  //               gap: 2,
  //               width: "100%",
  //             }}
  //           >
  //             <Button
  //               variant="contained"
  //               size="large"
  //               onClick={() => navigate(`/my-properties/${successPropertyId}`)} // Navigate to details
  //               endIcon={<ArrowForwardIcon />}
  //             >
  //               View Property
  //             </Button>
  //             <Button variant="outlined" onClick={() => navigate("/dashboard")}>
  //               Go to Dashboard
  //             </Button>
  //           </Box>
  //         </Paper>
  //       </Container>
  //     );
  //   }

  return (
    <Container sx={{ mt: 5, mb: 5 }}>
      {/* Header */}
      <Typography variant="h4" component="h1" align="center" gutterBottom>
        Add Property
      </Typography>

      {/* Stepper */}
      <Stepper
        activeStep={activeStep}
        // sx={{ mb: 4, pt: 3, pb: 5 }}
        sx={{ pt: 3, pb: 5 }}
        alternativeLabel
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {/* Main Form Box */}
      <Box
        component="form"
        noValidate
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          maxWidth: 800,
          mx: "auto",
        }}
      >
        {/* Messages */}
        {errMsg && (
          <Alert
            severity="error"
            ref={errRef}
            tabIndex={-1}
            action={
              <IconButton
                size="small"
                onClick={() =>
                  //   setErrors((prev) => ({ ...prev, mainImage: false }))
                  setErrMsg("")
                }
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
            {errMsg}
          </Alert>
        )}
        {success && (
          <Alert severity="success" ref={successRef} tabIndex={-1}>
            New property created successfully!{" "}
            <Link
              to={`/my-properties/${success}`}
              style={{ color: "inherit", fontWeight: "bold" }}
            >
              Click here to Review & Publish
            </Link>
          </Alert>
        )}

        <>
          {/* Form Content */}
          {renderStepContent(activeStep)}

          {/* Navigation Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 3,
            }}
          >
            {activeStep !== 0 && (
              <Button onClick={handleBack} variant="outlined" color="inherit">
                Back
              </Button>
            )}

            {activeStep === steps.length - 1 ? (
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={isLoading || success}
                startIcon={
                  isLoading && <CircularProgress size={20} color="inherit" />
                }
              >
                {isLoading
                  ? "Saving..."
                  : success
                  ? "Property Saved"
                  : "Submit Property"}
              </Button>
            ) : (
              <Button variant="contained" onClick={handleNext}>
                Next
              </Button>
            )}
          </Box>
        </>
      </Box>
    </Container>
  );
};

export default AddProperty;
